import { render, staticRenderFns } from "./img.vue?vue&type=template&id=65e24f0a&scoped=true&"
import script from "./img.vue?vue&type=script&lang=js&"
export * from "./img.vue?vue&type=script&lang=js&"
import style0 from "./img.vue?vue&type=style&index=0&id=65e24f0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e24f0a",
  null
  
)

export default component.exports